<template>
  <s-task-list-layout
    :title="$t('PublicServant.Me.AL.DAFConfirmed')"
    :back-u-r-l="isESign ? '/tasklist/eSignList' : '/tasklist/outboxList'"
    @searchIconClick="onServerSearchIconClick"
  >
    <template v-slot:search-area>
      <!--
      <s-filter-box
        ref="filterBox"
        :is-search-status="true"
        :issue-entities-with-all="issueEntitiesWithAll"
        @filterChange="filterTaskList"
      />
      -->
      <s-server-filter-box
        ref="filterBox"
        @search="search"
      />
    </template>
    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <s-class-pdf-muti
      v-model="dialog"
      :file-ctxs="files"
    />
    <div v-show="!loading">
      <v-card
        v-for="(task,i) in taskList"
        :key="i"
        flat
        color="white"
        class="mb-4"
      >
        <v-card-text>
          <div>
            {{ $t('TaskList.ConfirmationTime') }} : {{ task.completedTime }}
          </div>
          <s-flow-view-doc-btn
            class="float-right"
            :has-ref-file="task.formAttribute.referenceDocumentList.length > 0"
            @previewOficioFile="previewOficioFileList(task)"
            @previewRefFile="previewRefFileList(task)"
          />
          <p class="text-h6 text--primary">
            {{ $chPtObjData('chinTaskListTitle', task.formAttribute) }}
          </p>

          <div class="mb-2">
            {{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}
            <br>
            {{ $chPtObjData('chinTaskListDesc2', task.formAttribute) }}
          </div>
          <!-- <div>{{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}</div> -->

          <div
            v-if="!isESign && entityAdministrativeSupportRelation.length > 0"
            class="text-body-2"
          >
            {{ $t('Outbox.IssueDept') }}: {{ $chPtObjData('issueEntityChinName', taskListProps[i]) }}
          </div>
          <div v-if="!isESign && taskListProps[i].receiveEntities.length > 0">
            <div class="text-body-2 text--grey">
              {{ $t('Outbox.ReceiveDept') }} ({{ taskListProps[i].receiveEntities.length }}{{ $t('Outbox.Count') }})
            </div>
            <div class="text-body-2 text--primary mb-4">
              <span
                v-for="(entity,k) in taskListProps[i].receiveEntities.slice(0, 3)"
                :key="k"
                class="entity-list-item"
              >
                {{ $chPtObjData('chinName', entity) }}
                <template v-if="k !== taskListProps[i].receiveEntities.slice(0, 3).length - 1">
                  ,
                </template>
              </span>

              <template v-if="taskListProps[i].receiveEntities.length > 3">
                ...
                <s-flow-all-entities
                  :entities="taskListProps[i].receiveEntities"
                  :title="$t('Outbox.ReceiveDept')"
                />
              </template>
            </div>
          </div>

          <div v-if="!isESign && taskListProps[i].ccEntities.length > 0">
            <div class="text-body-2 grey--text">
              {{ $t('Outbox.CCDept') }} ({{ taskListProps[i].ccEntities.length }}{{ $t('Outbox.Count') }} - <span v-if="taskListProps[i].isCarbonCopyAttachments">{{ $t('Outbox.CCWithAttachment') }}</span><span v-else>{{ $t('Outbox.CCWithoutAttachment') }}</span>)
            </div>
            <div class="text-body-2">
              <span
                v-for="(entity,k) in taskListProps[i].ccEntities.slice(0, 3)"
                :key="k"
                class="entity-list-item"
              >
                {{ $chPtObjData('chinName', entity) }}
                <template v-if="k !== taskListProps[i].ccEntities.slice(0, 3).length - 1">
                  ,
                </template>
              </span>

              <template v-if="taskListProps[i].ccEntities.length > 3">
                ...
                <s-flow-all-entities
                  :entities="taskListProps[i].ccEntities"
                  :title="$t('Outbox.CCDept')"
                />
              </template>
            </div>
          </div>
          <v-tooltip
            v-if="$config.isShowEncrypted && taskListProps[i].isEncryptedDoc"
            top
            color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                outlined
                :color="taskListProps[i].securityLevelId > 2 ? 'purple' : 'info'"
                v-bind="attrs"
                v-on="on"
              >
                {{ getSecurityLevel(taskListProps[i]) }}
              </v-chip>
            </template>
            <span>
              {{ getSecurityLevel(taskListProps[i]) }}
            </span>
          </v-tooltip>

          <div class="text--primary">
            <!--
            {{ $t('Outbox.PreviousHandler') }}: {{ $chPtObjData('chinStaffName', task.workItemHistoryList[0]) }} - {{ task.workItemHistoryList[0].message }}
            -->
            <s-flow-history
              :work-item="task"
              :text="$t('TaskList.ProcessDetail')"
            />
          </div>

          <!-- <div
              v-if="task.status === 'H' && task.actionTypeId === 2"
              class="text--primary"
            > -->
          <div
            v-if="task.status !== 'A' && task.actionTypeId === 2 && !isESign"
            class="text--primary"
          >
            <s-e-doc-x-status
              :approver-euid="taskListProps[i].approverEuid"
              :is-urgent="taskListProps[i].isUrgent"
              :is-direct-send-to-edocx="taskListProps[i].isDirectSendToEDocX"
              :oficio-id="parseInt(task.formAttribute.formIdentity)"
              :text="$t('Outbox.eDocX.Status')"
            />
          </div>

          <br>

          <v-chip
            v-if="taskListProps[i].isDirectSendToEDocX"
            class="mr-2"
            outlined
            color="red"
          >
            {{ $t('Outbox.DirectSendAfterSign') }}
          </v-chip>
          <v-chip
            v-if="taskListProps[i].isUrgent"
            class="mr-2"
            outlined
            color="red"
          >
            {{ $t('Outbox.Urgent') }}
          </v-chip>
        </v-card-text>
        <v-card-actions>
          <div class="px-2">
            {{ $t('Text.Status') }}:
            <!-- <template v-if="task.status === 'H' && task.actionTypeId === 2"> -->
            <template v-if="task.status !== 'A' && task.actionTypeId === 2">
              <span class="primary--text">{{ $t('TaskList.Status.Signed') }}</span>
            </template>
            <!-- <template v-else-if="task.status === 'H' && task.actionTypeId === 3"> -->
            <template v-else-if="task.status !== 'A' && (task.actionTypeId === 3)">
              <span class="error--text">{{ $t('Text.Cancel.ed') }}</span>
            </template>
            <template v-else>
              <span class="primary--text">{{ $t('TaskList.Status.Processing') }}</span>
            </template>
          </div>
          <v-spacer />

          <v-tooltip
            v-if="task.canRecall"
            top
            color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="waiting"
                large
                icon
                v-bind="attrs"
                class="mr-2"
                v-on="on"
                @click="recallJob(getHistoryItems, task)"
              >
                <v-icon color="deep-orange">
                  {{ mdiUndoVariant }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('TaskList.TakeBackDoc') }}</span>
          </v-tooltip>

          <!-- <v-btn
            style="margin-right: 20px;"
            @click="previewOficioFileList(task)"
          >
            {{ $t('Outbox.PreviewUploadFile') }}
          </v-btn>
          <v-btn
            style="margin-right: 20px;"
            @click="previewRefFileList(task)"
          >
            查閱參考文件
          </v-btn> -->
        </v-card-actions>
      </v-card>

      <template v-if="taskList.length === 0">
        <v-card
          flat
          class="mt-2 py-6"
        >
          <v-card-text class="text-body-1 black--text">
            {{ $t('PublicServant.NoData') }}
          </v-card-text>
        </v-card>
      </template>
      <div>
        <v-pagination
          v-if="totalPage"
          v-model="page"
          :length="totalPage"
          circle
          @input="handlePageChange"
        />
      </div>
    </div>
    <p class="px-4 text-caption grey--text">
      *{{ $t('Workflow.OnlyShowXMonths', {'0': '3'}) }}
    </p>
  </s-task-list-layout>
</template>

<script>

import store from '../../store'
import { mapState } from 'vuex'

import SFlowViewDocBtn from './components/OutboxList/SFlowViewDocBtn'
import SFlowAllEntities from './components/OutboxList/SFlowAllEntities'
import STaskListLayout from './components/STaskListLayout'
import { workflowModule, staffModule } from '../../store/moduleName'
import { TASK_LIST_JOB_TYPE } from '@/constant/constant'
import SFlowHistory from './components/OutboxList/SFlowHistory'
import SEDocXStatus from './components/OutboxList/SEDocXStatus'
import SClassPdfMuti from '@/components/SClassPdfMuti'
import { taskMethod } from '../../mixins/taskMethod'
import { outboxBasic } from './mixins/outboxBasicMixin'
import { workflow } from '../../store/modules/workflow/workflow'
// import workflowApi from '@/api/workflow/workflow'
// import { breakSubErrors } from '@/utils/messageUtil'
// import SFilterBox from './components/GeneralList/SFilterBox'
import SServerFilterBox from './components/GeneralList/SServerFilterBox'
import { mdiUndoVariant, mdiApplicationImport } from '@mdi/js'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
    // SFilterBox,
    SServerFilterBox,
    SEDocXStatus,
    SFlowViewDocBtn,
    SFlowAllEntities,
    STaskListLayout,
    SFlowHistory,
    SClassPdfMuti
  },
  mixins: [taskMethod, outboxBasic],
  data: function () {
    return {
      mdiUndoVariant: mdiUndoVariant,
      mdiApplicationImport: mdiApplicationImport,
      jobType: TASK_LIST_JOB_TYPE.MY_JOB,
      loading: true,
      waiting: false,
      taskListProps: [],
      files: [],
      dialog: false,
      isShowSearchArea: false,
      itemsPerPage: 10,
      page: 1,
      totalPage: 0,
      // issueEntities: [],
      // filterSubunitId: null,
      // filterText: null,
      // filteredTaskList: [],
      // filteredTaskListProps: [],
      taskList: [],
      filterText: ''
    }
  },
  computed: {
    ...mapState({
      // taskList: state => state[workflowModule].historyWorkItems,
      staff: state => state[staffModule].info
    })
    // issueEntitiesWithAll () {
    //   return [{
    //     issueEntityId: null,
    //     issueEntityAbbr: null,
    //     issueEntityChinName: null,
    //     issueEntityPortName: null,
    //     issueSubunitEntityId: null,
    //     issueSubunitEntityAbbr: null,
    //     issueSubunitEntityChinName: '所有',
    //     issueSubunitEntityPortName: 'Todos'
    //   }, ...this.issueEntities]
    // }
  },
  watch: {
    taskList: function (val) {
      // this.genTaskListProps(val) // change to call in getHistoryItems
      // this.filterTaskList()
    }
    // filterSubunitId: function (val) {
    //   this.filterTaskList()
    // },
    // filterText: function (val) {
    //   this.filterTaskList()
    // }
  },
  async created () {
    this.getEntityAdministrativeSupportRelation()
    this.getHistoryItems()
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
  },
  methods: {
    handlePageChange (value) {
      this.page = value
      this.getHistoryItems()
    }
    /*
    async getHistoryItems () {
      this.loading = true
      // this.$store.dispatch(workflowModule + '/getItemByBusinessCode', this.businessCode)
      await this.$store.dispatch(workflowModule + '/getHistoryItems', this.businessCode)
      this.loading = false
    }
    */
    // searchIconClickHandler () {
    //   this.isShowSearchArea = !this.isShowSearchArea
    //   if (this.isShowSearchArea) {
    //     this.$nextTick(() => {
    //       this.$refs.filterTextField.focus()
    //     })
    //   }
    // },
  }
}
</script>
